import { Component, Input, OnInit } from '@angular/core';
import { MainService } from 'src/app/services/main.service';
import { MapService } from "../../../../services/map.service";
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { GeoJSON } from "ol/format";
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import BingMaps from 'ol/source/BingMaps';

@Component({
  selector: 'app-map-home',
  templateUrl: './map-home.component.html',
  styleUrls: ['./map-home.component.scss']
})
export class MapHomeComponent implements OnInit {
  map;
  filtroGEP: any[];
  capa: any;
  toggle_MapaBase = false
  tooltip = "OSM"

  constructor(
    public mapService: MapService,
    public mainservice: MainService
  ){
    this.mainservice.filtroGEP$.subscribe( async variable =>{
      this.filtroGEP = variable;
      await this.zoomTo()
    })
    this.mapService.CapaMapaHome$.subscribe( async capa => {
      this.capa = capa;
      this.addCapas()
    })
  }

  ngOnInit() {
    this.map = this.mapService.nuevoMapa("map-home")
    this.addCapas();
  }

  addCapas(){
    this.mapService.agregarCapa(this.capa, this.filtroGEP, this.map);
    this.removeLayers()
  }

  async zoomTo(){
    await this.mapService.CallLimites(this.filtroGEP).then( geojson => {
      const source = new VectorSource({
        features: new GeoJSON().readFeatures(geojson,{
          dataProjection: 'EPSG:4326', //geojson projection
          featureProjection:'EPSG:3857', //view projection
          })
      });
      const styleL = new Style({
        stroke: new Stroke({
            width: 2,
            color: 'red',
            lineDash: [.1, 5] //or other combinations
        }),
        zIndex: 2
    })
      var vectorLayer = new VectorLayer({
        source: source,
        style: styleL
      });
      vectorLayer.set('name', "Limites");
      this.map.addLayer(vectorLayer);
      this.map.getView().fit(source.getExtent(), this.map.getSize());
    });
  }

  SeleccionMapaBase(){
      this.toggle_MapaBase = !this.toggle_MapaBase;
      this.map.getLayers().forEach((lyr) => {
        if(lyr && lyr.get('name') == 'CapaBase'){
          this.map.removeLayer(lyr)
        }
      })
      let base = null
      if(this.toggle_MapaBase){
        this.tooltip = "Satelite"
        base = new TileLayer({
          visible: true,
          preload: Infinity,
          source: new OSM({})
        })
      }else{
        this.tooltip = "OSM"
        base = new TileLayer({
          visible: true,
          preload: Infinity,
          source: new BingMaps({
            key:
              "Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j",
            imagerySet: "AerialWithLabelsOnDemand",
          })
        })
      }
      base.set('name', 'CapaBase');
      this.map.getLayers().insertAt(0,base);
      
  }

  removeLayers(){
    this.map.getLayers().forEach((lyr) => {
      if(lyr.get('name') != 'CapaBase' && lyr.get('name') != 'Limites' && lyr.get('name') != this.capa.name){
        this.map.removeLayer(lyr)
      }
    })
  }

}
